import styled from 'styled-components';

export const Base = styled.div<{ $align?: 'left' | 'center' | 'right' }>`
	display: flex;
	align-items: center;
	justify-content: ${({ $align }) =>
		$align === 'left' ? 'flex-start' : $align === 'right' ? 'flex-end' : 'center'};
	position: relative;
	min-width: 0;

	${({ $align, theme }) =>
		$align === 'left' &&
		`
		&::before {
			content: '';
			position: absolute;
			left: 0;
			top: -4px;
			bottom: -4px;
			width: 1px;
			background-color: ${theme.gray[200]};
		}
	`}
`;
